// Единые ширины для страниц "Детали": фиксированный max-width вместо дробных `w-2/3`,
// чтобы карточки и поля ввода не растягивались на весь экран и не зависели от ширины родителя.
export const DETAIL_CARD_CLASS = "card w-full max-w-full";
export const DETAIL_FIELD_CLASS = "w-full max-w-full";
export const DETAIL_TEXTAREA_CLASS = "w-full max-w-full";

export const YES_NO_OPTIONS = [
    { label: "Да", value: true },
    { label: "Нет", value: false },
];
